export default __webpack_public_path__ + "static/media/location.8c85255f.svg";